<template>
    <div class="content">
        <div class="col-md-8 flex-container-top">
            <base-button type="primary" round icon class="top-button-back" @click="$router.push('list')">
                <i class="fa fa-arrow-left"></i>
            </base-button>

            <h2 v-if="!isEdit" class="text-center">Add Event Schedule</h2>
            <h2 v-if="isEdit" class="text-center">Edit Event Schedule</h2>
        </div>
        <div class="row">
            <div class="col-md-12">
                <card>
                    <form onSubmit="return false;">
                        <div class="row">
                            <div class="col-md-6">
                                <base-input type="text" :label="column1" :placeholder="column1"
                                    v-model="value1">
                                </base-input>
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-md-6">
                                <base-input type="text" :label="column2" :placeholder="column2"
                                    v-model="value2">
                                </base-input>
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-md-6">
                                <base-input type="text" :label="column3" :placeholder="column3"
                                    v-model="value3">
                                </base-input>
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-md-6">
                                <label>{{ column4 }}</label>
                                <input class="location form-control" id="auto-complete-text" v-model="value4"
                                    :placeholder="column4" @keydown.enter.prevent />
                            </div>
                        </div>
                        <hr>

                        <base-button v-if="!isEdit" native-type="submit" type="primary" @click="AddScheduale()"
                            class="btn-fill" :disabled="loading">Save
                        </base-button>

                        <base-button v-if="isEdit" native-type="submit" type="primary" @click="UpdateScheduale()"
                            class="btn-fill" :disabled="loading">Update
                        </base-button>

                    </form>
                </card>
            </div>
        </div>

        <div class="full-screen-loader" v-if="loading">
            <div class="sk-chase">
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
            </div>
        </div>
    </div>
</template>

<script>

import { ImageUpload } from "src/components/index";

export default {
    components: {
        ImageUpload,
    },
    data() {
        return {
            value1: "",
            value2: "",
            value3: "",
            value4: "",
            column1: "",
            column2: "",
            column3: "",
            column4: "",
            isEdit: false,
            loading: false,
        };
    },

    async mounted() {

        let id = this.$route.query.id;
        this.loading = true;
        if (id == -1) {
            this.isEdit = false;
            let eve = await this.$apiService.getCall("schedulekey/schedule-key/");
            console.log('apidata', eve);
            if (eve.apidata.Code === "P00001") {
                this.column1 = eve.apidata.Data.column1;
                this.column2 = eve.apidata.Data.column2;
                this.column3 = eve.apidata.Data.column3;
                this.column4 = eve.apidata.Data.column4;
            } else {
                this.$apiService.notify(eve.apidata.Message);
            }
        } else {
            this.isEdit = true;
            let eve = await this.$apiService.getCall("eventschedule/event-schedule/" + id);
            console.log('apidata', eve);
            if (eve.apidata.Code === "P00001") {
                this.value1 = eve.apidata.Data.value1;
                this.value2 = eve.apidata.Data.value2;
                this.value3 = eve.apidata.Data.value3;
                this.value4 = eve.apidata.Data.value4;
                this.column1 = eve.apidata.Data.column1;
                this.column2 = eve.apidata.Data.column2;
                this.column3 = eve.apidata.Data.column3;
                this.column4 = eve.apidata.Data.column4;
            } else {
                this.$apiService.notify(eve.apidata.Message);
            }
        }
        this.loading = false;

        var _self = this;

        var input = document.getElementById("auto-complete-text");

        var autocomplete = new google.maps.places.Autocomplete(input);

        google.maps.event.addListener(autocomplete, "place_changed", function () {
            var place = autocomplete.getPlace();
            _self.value4 = input.value;
        });

    },

    methods: {
        async UpdateScheduale() {

            var id = this.$route.query.id;
            if (
                !this.value1 &&
                !this.value2 &&
                !this.value3 &&
                !this.value4
            ) {
                this.$apiService.notify("All fields are mandatory.");
                return;
            }
            if (!this.value1 || this.value1.trim() === "") {
                this.$apiService.notify(`${this.column1} is mandatory.`);
                return;
            }

            if (!this.value2 || this.value2.trim() === "") {
                this.$apiService.notify(`${this.column2} is mandatory.`);
                return;
            }

            if (!this.value3 || this.value3.trim() === "") {
                this.$apiService.notify(`${this.column3} is mandatory.`);
                return;
            }

            if (!this.value4 || this.value4.trim() === "") {
                this.$apiService.notify(`${this.column4} is mandatory.`);
                return;
            }

            this.loading = true;

            var data = {
                value1: this.value1,
                value2: this.value2,
                value3: this.value3,
                value4: this._self.value4,
            };

            var update_schedule = await this.$apiService.postCall(
                "eventschedule/update-event-schedule/" + id,
                data
            );
            console.log("update_schedule", update_schedule)
            if (update_schedule.apidata.Code === "P00001") {
                this.$apiService.notify("Schedule has been updated.");
                this.$router.push("/eventschedule/list");
            } else {
                this.$apiService.notify("Something went wrong in Scheduale updating.");
            }
            this.loading = false;
        },

        async AddScheduale() {
            if (
                !this.value1 &&
                !this.value2 &&
                !this.value3 &&
                !this.value4
            ) {
                this.$apiService.notify("All fields are mandatory.");
                return;
            }
            if (!this.value1 || this.value1.trim() === "") {
                this.$apiService.notify(`${this.column1} is mandatory.`);
                return;
            }

            if (!this.value2 || this.value2.trim() === "") {
                this.$apiService.notify(`${this.column2} is mandatory.`);
                return;
            }

            if (!this.value3 || this.value3.trim() === "") {
                this.$apiService.notify(`${this.column3} is mandatory.`);
                return;
            }

            if (!this.value4 || this.value4.trim() === "") {
                this.$apiService.notify(`${this.column4} is mandatory.`);
                return;
            }
            this.loading = true;

            var add_schedule = await this.$apiService.postCall("eventschedule/add-event-schedule/", {
                value1: this.value1,
                value2: this.value2,
                value3: this.value3,
                value4: this._self.value4,
            });
            console.log("add_schedule", add_schedule)
            if (add_schedule.apidata.Code === "P00001") {
                this.$apiService.notify("Scheduale has been added.");
                this.$router.push("/eventschedule/list");
            } else {
                this.$apiService.notify("Something went wrong in Scheduale adding.");
            }
            this.loading = false;
        },
    }
};
</script>